import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationSubscriptionsPlanList = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
